import React from 'react'
// @src imports
import { Button, Icon } from 'src/chrome'
import { dollarsAndCents } from 'src/helpers'
import { PlanFragment } from 'src/graphql'
import { Plan, PlanDetails } from 'src/marketing/plans/types'

import { colors, style } from './pricingTableStyles'

type PlanTileProps = {
  plan: Plan | PlanFragment
  details?: PlanDetails
  containerStyle?: React.CSSProperties
  onSelect: (plan: string) => void
  isCurrentPlan: boolean
  hideButton?: boolean
  getPlan: (planId: string) => PlanFragment | undefined
}

// tslint:disable-next-line: cyclomatic-complexity score 27
const PlanTile: React.FC<PlanTileProps> = props => {
  const { plan, details, onSelect, containerStyle, hideButton = false } = props
  const amount = dollarsAndCents(plan.price.amount ?? 0)
  const primary: string = plan.color
    ? (colors.primary as any)[plan.color]
    : colors.white
  const secondary: string = plan.color
    ? (colors.secondary as any)[plan.color]
    : colors.white
  const tertiary: string = plan.color
    ? (colors.tertiary as any)[plan.color]
    : colors.white

  const tileBackground: string = colors.white
  return (
    <div
      style={{
        background: tileBackground,
        ...style.planHeader,
        ...containerStyle,
      }}
    >
      <div
        style={{
          ...style.titleBlock,
          borderBottom: `.5px solid ${secondary}`,
        }}
      >
        <h2 style={{ ...style.planTitle, color: primary }}>
          {plan.title.toUpperCase()}
        </h2>
      </div>
      <div style={style.amountBlock}>
        <div style={{ display: 'flex' }}>
          <div style={{ marginTop: 10 }}>
            <Icon icon={'DOLLARSIGN'} size={18} color={secondary} />
          </div>
          <span style={{ ...style.dollarAmount, color: secondary }}>
            {amount.dollars}
          </span>
          <span
            style={{
              ...style.centsAmount,
              color: secondary,
            }}
          >{`.${amount.cents}`}</span>
        </div>
        <div style={{ color: tertiary }}>/ month</div>
        {details && (
          <ul style={{ marginTop: 15, fontSize: 14 }}>
            {details.details &&
              details.details.map(detail => (
                <li
                  key={detail.detail}
                  style={{
                    ...{ listStyleType: 'none', padding: '3px 0' },
                    ...{ listStyleType: 'none', color: 'rgba(0,0,0,.55)' },
                  }}
                >
                  {detail.innerDetails && (
                    <>
                      <div>{detail.detail}</div>
                      <div>(postage not included)</div>
                      <ul>
                        {detail.innerDetails.map(innerDetail => (
                          <li
                            key={innerDetail.detail}
                            style={{
                              ...{
                                listStyleType: 'none',
                                padding: '3px 0',
                                paddingLeft: '12px',
                              },
                              ...{
                                listStyleType: 'none',
                                color: 'rgba(0,0,0,.55)',
                              },
                            }}
                          >
                            {innerDetail.detail}
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                  {!detail.innerDetails && detail.detail}
                </li>
              ))}
          </ul>
        )}
        {!hideButton && (
          <Button
            id={`add_${plan.title.toLowerCase()}_btn`}
            title={'Select'}
            onClick={() => onSelect(plan.title)}
            style={{
              ...style.selectButton,
            }}
          />
        )}
      </div>
    </div>
  )
}

export default PlanTile
